import { Injectable } from "@angular/core";
import { GqlServiceV2 } from "../../modules/content/service/gql.service-v2";
import { GridInput } from "@it2go/data-grid";
import { GeneralLedgerReportObject } from "@libs/types/src/mado/object-type";
import { filterFrag } from "../types/filter.types";

@Injectable({ providedIn: 'root' })
export class MadoReportService extends GqlServiceV2 {

  public getGeneralLedgerReport(input: GridInput | null, frag: string) {
    return this.query<GeneralLedgerReportObject>(
      `
        query($input: GridInput!) {
          accountingReport {
            generalLedgerReport(input: $input) {
              ${filterFrag}
              items {
                  ${frag}
              }
            }
          }
        }
      `,
      { input },
    );
  }
}
